<template>
  <div class="breadcrumbs-wrapper w-full order-2 md:order-1">
    <div class="breadcrumbs py-16 flex container xxl:px-24">
      <div class="swiper-container swiper-breadcrumbs">
        <div class="swiper-wrapper">
          <div
            v-for="(r, i) in splitRoutes"
            :key="r.route"
            class="crumb swiper-slide flex items-center mr-8 last:mr-0"
            :class="{
              'desktop-slide': !uiStore.isMobile,
            }"
          >
            <nuxt-link v-if="currentRoute !== r.route" :to="r.route">
              {{ `&nbsp;${r.title}&nbsp;` }}
            </nuxt-link>
            <template v-else>
              {{ `&nbsp;${r.title}&nbsp;` }}
            </template>
            <fa
              v-if="splitRoutes[i + 1]"
              class="text-xxs ml-8"
              :icon="['far', 'chevron-right']"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type Product from '~/models/product';
import { useConfigStore } from '~/store/config';
import { trailingSlashit } from '~/util/strings';
import { useUiStore } from '~/store/ui';
const config = useConfigStore();

const uiStore = useUiStore();

interface Props {
  product?: Product | null,
}

const props = withDefaults(defineProps<Props>(), {
  product: null,
});

const splitRoutes = computed(()=> {
  if (props.product) {
    const genderRoute = config.findGenderProductList(
      props.product.gender[0]
    );
    const typeRoute = config.findTypeProductList(
      props.product.gender[0],
      props.product.type[0]
    );
    const arr = [];
    if (genderRoute) {
      arr.push(genderRoute);
    }
    if (typeRoute) {
      arr.push(typeRoute);
    }
    return arr;
  } else {
    const breadcrumbs = config.routeData(currentRoute.value)?.breadcrumbs;

    if (breadcrumbs && breadcrumbs.length) {
      return breadcrumbs as any[];
    }

    const split = currentRoute.value
      .split('/')
      .slice(2)
      .filter((i) => i && i.length);

    return split.map((r, i) => {
      return {
        title: config.routeData(r.split('-')[0])?.title ?? r.split('-')[0],
        route: trailingSlashit(
          trailingSlashit(config.home_url) + split.slice(0, i + 1).join('/')
        ),
      } as any;
    });
  }
});

const route = useRoute();

const currentRoute = computed<string>(() => {
  return trailingSlashit(route.path);
});

</script>

<style scoped lang="postcss">
  .breadcrumbs {
    .swiper-container {
      margin-left: 0;
      margin-right: 0;
      .swiper-slide {
        width: auto;
        @apply text-black-50 text-sm capitalize;
      }
    }
  }
  .productInformation {
    .breadcrumbs-mobile {
      .breadcrumbs {
        @apply px-0;
      }
    }
  }
</style>
